function setAffirmTrigger(element) {
    var parent = element.closest('.affirm-trigger-container'); // Find the parent div dynamically
    if (!parent) {
      parent = document.querySelector('.affirm-trigger-container');
    }
    const targetDiv = parent.querySelector('.affirm-modal-trigger'); // Find the target div within the parent div
    targetDiv.click(); // Trigger a click event on the target div
  }